module.exports = __webpack_public_path__ + "static/media/service-plain-bg.0b20ffde.png";